module.exports = __webpack_public_path__ + "static/media/siel-bleu-spain.22b93b69.svg";